import React from 'react';

import { connect, Provider } from 'react-vuex';

import vuexStore from '../../../shared/store';
import { EventBus } from '../../../shared/event-bus';

function mapDispatchToProps(dispatch) {
  return {
    addItemToCart: (product) => dispatch('cart/addItem', product),
  };
}

export const _ProductCard = connect(
  () => ({}),
  mapDispatchToProps,
  () => ({}),
  () => ({})
)(({ id, price, name, title, region_name, tier, ranked, division, url, addItemToCart, details, product_image }) => {
  const onAddToCart = (event) => {
    addItemToCart({
      description: 'Valorant ' + title,
      price: parseFloat(price),
      extra: { id, type: 'valorant' },
    });

    // The button is sometimes nested in clickable cards, which we don't
    // want to click when adding an item to the cart.
    event.stopPropagation();


    EventBus.$emit('item-added-to-cart');
  };
  return (
    <div className="product-card">
      <div
        className="product-card__inner"
        onClick={() => {
         window.location = url;
        }}
      >

        <div className="product-card__upper">
          <div className="product-card__header">
            <div className="product-card__region-label">
              {region_name} REGION
            </div>
            <h4 className="product-card__rank">
              {name}
            </h4>
            <h4 className="product-card__description">
              {ranked ? 'Ranked' : 'Unranked'} ACCOUNT
            </h4>
          </div>
          <div className="product-card__header-image">
            <img src={product_image ?? `/images/valorant/valorant_${tier.toLowerCase()}.png`} />
          </div>
        </div>

        {details.length === 0 ? (

          <div>

            <div className="product-card__bullet">
              <i className="fa fa-check product-card__checkmark"></i>
              <p className="product-card__bullet-text">New Episode 6 Act 1</p>
            </div>
            <div className="product-card__bullet">
              <i className="fa fa-check product-card__checkmark"></i>
              <p className="product-card__bullet-text">
                Choose 0-2 agent of your OWN choice
              </p>
            </div>
            <div className="product-card__bullet">
              <i className="fa fa-check product-card__checkmark"></i>
              <p className="product-card__bullet-text">
                Valorant Rank: {tier} {division && division}
              </p>
            </div>
            <div className="product-card__bullet">
              <i className="fa fa-check product-card__checkmark"></i>
              <p className="product-card__bullet-text">Lifetime Warranty</p>
            </div>

          </div>

          ) : (

            details.map(detail => (
              <span className="text-sm">
                <i className="fas fa-check text-smurfs-gold mr-1" />{detail} <br />
              </span>
            ))

          )}

        <div className="product-card__price">
          <div className="product-card__currency">USD</div>
          {price}
        </div>

        {/* <div className="product-card__original-price">USD 149.99</div> */}
        <div className="product-card__buttons">
          <button onClick={onAddToCart} className="product-card__cart-button">
            Add to cart
          </button>
          <a href={url} className="product-card__details-button">
            Acc. details
          </a>
        </div>
      </div>
    </div>
  );
});

export const ProductCard = (props) => {
  return (
    <Provider store={vuexStore}>
      <_ProductCard {...props} />
    </Provider>
  );
};
